export const getListOfAccounts = {
  GET_LIST_OF_ACCOUNTS_REQUEST: "GET_LIST_OF_ACCOUNTS_REQUEST",
  GET_LIST_OF_ACCOUNTS_SUCCESS: "GET_LIST_OF_ACCOUNTS_SUCCESS",
  GET_LIST_OF_ACCOUNTS_ERROR: "GET_LIST_OF_ACCOUNTS_ERROR",
};
